import { Injectable } from '@angular/core';
import { WidgetInstance } from 'friendly-challenge';
import * as moment from 'moment';
import { puzzleExpiry } from '../../shared/friendlycaptcha';

@Injectable({
  providedIn: 'root'
})
export class FriendlycaptchaService {

  constructor() { }

  createWidget(element: HTMLElement, doneCallback: (solution: string) => void = (): void => { }, errorCallback: (error: any) => void = (): void => { }): WidgetInstance {
    return new WidgetInstance(element, {
      startMode: 'none',
      doneCallback: (a) => {
        const expiry = puzzleExpiry(a);
        console.log('solution done: ' + a + ' expiry: ' + moment(new Date(expiry)).utc().format('HH:mm:ss'));
        doneCallback(a);
      },
      errorCallback: (b) => {
        console.log('solution failed: ', b);
        errorCallback(b);
      },
    });
  }
}
